module.exports = __webpack_public_path__ + "img/1572263304.bd847998.jpg";